module.exports = __webpack_public_path__ + "static/img/noData.c1301893.png";